// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"99326dde","282":"a99184a5","368":"d8f72b6b","407":"791568e9","508":"b61a703d","571":"b3e5e85f","956":"6ce28512"}[chunkId] + ".chunk.js";
};